.header {
  vertical-align: middle;
  text-align: center;
  height: 30px;
  width: 30px;
}

.day {
  font-size: 12px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.outside {
  opacity: 0.5;
}

.today:not(.outside) {
  font-weight: 700;
}

.selected {
  color: white;
  opacity: 1;
  background-color: var(--main-text);
}

.day:hover:not([disabled], .selected) {
  background-color: #e7edff;
}
